import { formatDate } from '@/shared/utils/format';
import type { Pick } from '../api/communityApi';

/** A pick's one-line meta: the event date (and distance), or the distance and category. */
export function metaFor(pick: Pick): string {
  if (pick.kind === 'event' && pick.eventStart) {
    const when = formatDate(pick.eventStart, 'EEE MMM d');
    return pick.distanceMi > 0 ? `${when} · ${pick.distanceMi} mi` : when;
  }
  return `${pick.distanceMi} mi · ${pick.categoryLabel.toLowerCase()}`;
}
